module.exports = __webpack_public_path__ + "static/27-0078c2eeac066b72c76e7466a01c250f.jpg";